import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function DreamSection() {
  return <section className="py-20 md:py-32 bg-ink relative overflow-hidden" data-id="element-111">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-112">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-113"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-114"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-8" data-id="element-116">
          <div className="flex justify-center mb-4" data-id="element-117">
            <Sparkles className="text-gold w-10 h-10" data-id="element-118" />
          </div>

          <h2 className="font-script text-5xl md:text-6xl text-gold mb-12" data-id="element-119">
            Imagínate esto:
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-cream/90 font-light text-left md:text-center max-w-3xl mx-auto" data-id="element-120">
            <p data-id="element-121">
              Es la noche de la boda de tu hija. El salón brilla. La música
              suena. Todos están felices.
            </p>

            <p data-id="element-122">
              Y en un rincón elegante del salón — enmarcado por una alfombra
              roja y postes dorados — hay un espejo luminoso oval que parece
              sacado de una película.
            </p>

            <p data-id="element-123">
              Los invitados se acercan curiosos. Lo tocan. El espejo cobra vida.
            </p>

            <p data-id="element-124">
              Se ríen. Se abrazan. Hacen caras chistosas. Se toman fotos serias
              y elegantes.
            </p>

            <p className="text-gold font-medium" data-id="element-125">
              Y en segundos — literalmente segundos — sale una foto impresa,
              personalizada con el nombre del evento y la fecha.
            </p>

            <div className="py-6 border-l-2 border-gold pl-6 md:border-l-0 md:pl-0 md:border-y md:border-gold/20 md:py-8 my-8" data-id="element-126">
              <p className="mb-4" data-id="element-127">
                La abuelita toma esa foto entre sus manos temblorosas.
              </p>
              <p className="mb-4" data-id="element-128">La mira. Te mira a ti.</p>
              <p className="font-serif text-2xl md:text-3xl text-cream italic" data-id="element-129">
                Y dice: "Esta me la llevo a México. La voy a poner en la pared
                junto a la foto de mis padres."
              </p>
            </div>

            <p className="text-xl md:text-2xl font-medium text-center pt-4" data-id="element-130">
              Eso es lo que nosotros hacemos.
            </p>
          </div>

          <div className="pt-12 mt-12 border-t border-gold/10" data-id="element-131">
            <p className="font-script text-4xl md:text-5xl lg:text-6xl text-gold leading-tight" data-id="element-132">
              "No vendemos fotos. Creamos el momento en que tu familia tiene
              algo para atesorar toda la vida."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}